import { render, staticRenderFns } from "./zuofengche.vue?vue&type=template&id=257253a2&"
import script from "./zuofengche.vue?vue&type=script&lang=js&"
export * from "./zuofengche.vue?vue&type=script&lang=js&"
import style0 from "./zuofengche.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports